﻿$.fn.dxCtrlContentSondage = function custom_dxCtrlContentSondage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsondage dx-ctrl");
        this.createInstance(new cdxCtrlContentSondage(this, option));
    }
    return this;
}

window.cdxCtrlContentSondage = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivDetail = null
    var nbReponse = null
    function mConstruit() {
        container.empty()
        if (option.dataSondage.fini == "1") { container.addClass("texture_import_disable_projet_pipeline") }
        else { container.removeClass("texture_import_disable_projet_pipeline") }
        container.css("border-top", theme.border)

        mRempliBt()

        var $DivEntete = $("<div/>").appendTo(container)

        var dxTabs = $("<div/>").appendTo($DivEntete).dxTabs({
            dataSource: ["Résumé", "Réponses", "Modifier"],
            selectedItems: ["Résumé"],
            itemTemplate: function (itemData, itemIndex, itemElement) {
                var $note = $('<div>').append($("<b>" + itemData + "</b>"));
                if (itemData == "Réponses") {
                    option.bddCtrl.mAjaxCall({
                        command: "getsondagenbreponse",
                        id_sondage: option.dataSondage.id_sondage
                    }, function (data) {
                        itemElement.empty()
                        nbReponse = data.lstnb[0].nb_incomplet + data.lstnb[0].nb_complet
                        $note = $('<div>').append($("<span><b>" + itemData + "</b> " + data.lstnb[0].nb_incomplet + "&bull;" + data.lstnb[0].nb_complet + "/" + (data.lstnb[0].nb_incomplet + data.lstnb[0].nb_complet) + "</span>"));
                        itemElement.append($note);
                        itemElement.attr("title", data.lstnb[0].nb_incomplet + " réponse" + (data.lstnb[0].nb_incomplet > 1 ? "s" : "") + " incomplète" + (data.lstnb[0].nb_incomplet > 1 ? "s" : "") + "<br/>" + data.lstnb[0].nb_complet + " réponse" + (data.lstnb[0].nb_complet > 1 ? "s" : "") + " compète" + (data.lstnb[0].nb_complet > 1 ? "s" : "") + "")
                    })
                }
                itemElement.append($note);
            },
            onItemClick: function (e) {
                switch (e.itemData) {
                    case "Résumé":
                        mRempliResume()
                        break;
                    case "Réponses":
                        mRempliGridReponse()
                        break;
                    case "Modifier":
                        mRempliModifier()
                        break;
                }
            }
        })

        $DivDetail = $("<div/>").appendTo(container)

        resizeObserver.mAdd($DivEntete, function () {
            $DivDetail.css("height", "calc(100% - " + ($DivEntete.innerHeight() + 5) + "px)")
        })()


        mRempliResume()
    }

    var _sondageConsolide = null
    function mRempliResume() {
        $DivDetail.empty()
        var dxScrollDetail = $("<div/>").appendTo($DivDetail).dxScrollView({}).dxScrollView("instance")
        $("<div style='width:100%;'/>").appendTo(dxScrollDetail.content()).dxCtrlSondageConsolide({
            bddCtrl: option.bddCtrl,
            dataSondage: option.dataSondage,
            onContentReady: function (sondageConsolide) {
                _sondageConsolide = sondageConsolide
            }
        })
    }
    function mRempliGridReponse() {
        $DivDetail.empty()
        var opt = {
            bddCtrl: option.bddCtrl
        }
        opt.lstLstConditionBase = [[{ nom_champ: "id_sondage", ope: "=", valeur: [{ value: option.dataSondage.id_sondage }] }]]
        $("<div style='width:100%;'/>").appendTo($DivDetail).dxCtrlGridSondageReponse(opt)
    }
    function mRempliModifier() {
        $DivDetail.empty()
        $("<div style='width:100%;height:100%;margin:0;'/>").appendTo($DivDetail).dxCtrlContentSondagePageLst({
            bddCtrl: option.bddCtrl,
            dataSondage: option.dataSondage
        })
        if (nbReponse) {
            mNotify("Votre sondage dispose déjà de réponses (" + nbReponse + ").<br/>Si vous modifier vos questions (suppression de liste de choix, suppression ou ajout de question), cela peut modifier vos statistiques.", "warning", 10000)
        }
    }

    var lstItemToolBarSource = null
    function mRempliBt() {
        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }

        var itemsToolbar = []
        itemsToolbar.push({
            location: 'before',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style='padding:10px;'/>").appendTo(itemElement).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Nom",
                    value: option.dataSondage.nom,
                    width: 300,
                    //height: maxHeight,
                    onValueChanged: function (e) {
                        option.dataSondage.nom = ((e.value == null) ? "" : e.value)
                        option.bddCtrl.getObjet(option.dataSondage).mSaveChamp("nom")
                    },
                    onContentReady: function (e) {
                        window.setTimeout(function () { e.component.focus(); }, 500)
                        itemElement.find('.dx-texteditor-input').off('keydown.next')
                        itemElement.find('.dx-texteditor-input').on('keydown.next', function (e) {
                            const key = e.key || e.keyCode || e.which;
                            if (key === 'Enter' || key === 13) {
                                e.preventDefault();
                                let inputs = $('.dx-texteditor-input:visible');
                                let index = inputs.index(this);
                                if (index > -1 && index + 1 < inputs.length) {
                                    inputs.eq(index + 1).focus();
                                }
                            }
                        });
                    }
                })
            },
        })
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-print",
                    txtTooltip: "Imprimer les statistiques du sondage.",
                    onClick: function (e) {
                        if (!_sondageConsolide) return
                        var justeFinalise = _sondageConsolide.getSeulementFinaliseValue()
                        var dat = _sondageConsolide.getDateRef()
                        var url = option.bddCtrl.getObjet(option.dataSondage).objetMetier.mGetUrlLinkPrint(null, justeFinalise, dat.date_debut,dat.date_fin)
                        jaugeDemarrage.mShow()
                        option.bddCtrl.mAjaxCall({
                            command: "printurl",
                            url: url,
                            nom: option.dataSondage.nom
                        }, function (data) {
                            $("<div/>").dxCtrlPdfViewer({
                                urlPdf: data.urlpdf.substring(1)
                            })
                            jaugeDemarrage.mHide()
                        })
                    }
                });
            },
        })
        itemsToolbar.push(getToolbarSeparator())
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-anchor",
                    icon2: "fas fa-copy",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    txtTooltip: "Copier le lien du sondage pour utilisation.",
                    onClick: function (e) {
                        var url = option.bddCtrl.getObjet(option.dataSondage).objetMetier.mGetUrlLink()
                        var $temp = $("<input>");
                        $("body").append($temp);
                        $temp.val(url).select();
                        document.execCommand("copy");
                        $temp.remove();
                        mNotify("L'adresse du sondage <a href='javascript:void(0)'>" + url + "</a> a été copiée dans le presse-papier", "success", 6000)
                    }
                });
            },
        })
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    text: "Prévisualiser",
                    txtTooltip: "Prévisualiser le sondage<br/>La prévisualisation vous permets de visualiser la présentation de celui-ci sans que vos réponses soit enregistré dans votre sondage.",
                    onClick: function (e) {
                        var url = option.bddCtrl.getObjet(option.dataSondage).objetMetier.mGetUrlLink()
                        $("<div/>").appendTo("body").dxCtrlPreviSondage({
                            bddCtrl: option.bddCtrl,
                            idSondage: option.dataSondage.id_sondage,
                            dataSondage: option.dataSondage,
                            url: url
                        })
                    }
                });
            },
        })
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-arrow-up-right-from-square",
                    txtTooltip: "Créer une réponse au sondage<br/>Votre sondage sera affiché dans une page de votre navigateur et vous créera une ligne de réponse à celui-ci comme pour un répondant réel.<br/>Vous pouvez ainsi créer des réponses (et les supprimer par la suite).",
                    onClick: function (e) {
                        var url = option.bddCtrl.getObjet(option.dataSondage).objetMetier.mGetUrlLink()
                        window.open(url, "_blank")
                    }
                });
            },
        })
        itemsToolbar.push(getToolbarSeparator())
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-copy",
                    txtTooltip: "Dupliquer le sondage",
                    onClick: function (e) {
                        var newDataSondage = option.bddCtrl.getObjet("sondage").mGetNewData()
                        for (var prop in option.dataSondage) { newDataSondage[prop] = option.dataSondage[prop] }
                        newDataSondage.id_sondage = null
                        newDataSondage.id_utilisateur = option.bddCtrl.utiCourant.id_utilisateur
                        newDataSondage.nom = "(copie) " + newDataSondage.nom
                        var obj = option.bddCtrl.getObjet(newDataSondage)
                        obj.mSave(function (data) {
                            obj.mShowPopup()
                        })
                    }
                });
            },
        })
        itemsToolbar.push(getToolbarSeparator())
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td/>").appendTo($Tr)
                $("<div style=''/>").appendTo($Td).dxCtrlSwitch({
                    txtTooltip: "Fermer/ouvrir le sondage<br/>Un sondage fermé n'est plus accessible",
                    value: (option.dataSondage.fini == "1"),
                    onValueChanged: function (e) {
                        option.dataSondage.fini = ((e.value) ? "1" : "0")
                        option.bddCtrl.getObjet(option.dataSondage).mSaveChamp("fini")
                        if (option.dataSondage.fini == "1") { container.addClass("texture_import_disable_projet_pipeline") }
                        else { container.removeClass("texture_import_disable_projet_pipeline") }
                    }
                });
                var $Td = $("<td style='opacity:" + ((option.dataSondage.fini == "1") ? "1" : "0.2") + "'>Fermé</td>").appendTo($Tr)
            },
        })

        itemsToolbar.push(getToolbarSeparator())
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    txtTooltip: "Mettre à la corbeille",
                    onClick: function (e) {
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: e.component.element(),
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "25px")
                                $("<div style='padding-bottom:15px;'>Mettre le sondage<br/>à la corbeille</div>").appendTo(contentElement)
                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                    text: "Confirmez",
                                    onClick: function (e) {
                                        tt.hide()
                                        if (typeof option.dataSondage.id_fichier == 'undefined') {
                                            option.bddCtrl.getObjet(option.dataSondage).mDelData()
                                            page.mRemovePopup(option.dataSondage)
                                        } else {
                                            var actionF = new cFileManagerAction(option.bddCtrl, option.dataSondage.id_fichier, "corbeille",
                                                function () {
                                                    var popupPage = page.mGetPopupPage(option.dataSondage)
                                                    if (popupPage != null) popupPage.mDestroy()
                                                    //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
                                                })
                                            actionF.mStartTraitement()
                                        }
                                    }
                                })
                            }
                        }).dxCtrlTooltip("instance");
                        tt.show();
                    }
                });
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)
    }

    this.element = function () { return container }

    mConstruit();
}